import { useMutation, useQueryClient } from 'react-query';
import { BrokerFixChannelSettingsService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
// eslint-disable-next-line camelcase
import type { Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_SetBulkCompanyFixEngineDto } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { isFixEngineEnabledForBrokerQueryKey } from '../get/useGetIsFixEngineEnabledForBroker';
import { linkedCompaniesFixQueryKey } from '../get/useGetBrokerLinkedCompaniesFix';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';

export interface UsePostSetBulkCompanyFixEngineEnabledProps {
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>;
}

/**
 * POST …/broker-fix-channel-settings/set-bulk-company-fix-engine-enabled
 */
const usePostSetBulkCompanyFixEngineEnabled = ({
  handleRequest,
}: UsePostSetBulkCompanyFixEngineEnabledProps) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (
      payload: Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_SetBulkCompanyFixEngineDto
    ) => {
      return await handleRequest(
        BrokerFixChannelSettingsService.postApiAwardSettlementApiAppBrokerFixChannelSettingsSetBulkCompanyFixEngineEnabled(
          payload
        )
      );
    },
    {
      onSuccess: (_data, variables) => {
        const brokerCompanyId = variables.brokerCompanyId;
        void queryClient.invalidateQueries(['getFixConfigByBrokerCompany', brokerCompanyId]);
        void queryClient.invalidateQueries(isFixEngineEnabledForBrokerQueryKey(brokerCompanyId));
        void queryClient.invalidateQueries(linkedCompaniesFixQueryKey(brokerCompanyId));
        toast.success(
          <ToastComponent label='Success' message='Company Fix Configuration saved.' />
        );
      },
    }
  );
};

export default usePostSetBulkCompanyFixEngineEnabled;
